module.exports = __webpack_public_path__ + "img/Ebay.354a523a.svg";